import React from 'react'
import { FormattedMessage } from 'react-intl';

import { getError } from '../utility/formValidation'

const TextField = ({ field, label, value, persona, errors, onChange, note, type = "text", inputClass = "", maxLength = 30, ...rest }) => {
  const getErrorClass = () => !!getError(field, errors, persona) ? 'field--error' : '';
  const error = getError(field, errors, persona);
  return (
    <div {...rest}>
      <div className={`field ${getErrorClass()}`}>
        <div className="field__label"><FormattedMessage id={label} defaultMessage={label} /></div>
        <div className="field__textwrapper">
          <input name={field} className={`field__input ${inputClass}`} maxLength={maxLength}
            type={type} value={value} onChange={e => onChange(e, persona)} />
        </div>
        {!!error && !!error.message && <span className="field__message"><FormattedMessage id={error.message} /></span>}
        {note && <span className="field__note"><FormattedMessage id={note} /></span>}
      </div>
    </div>
  )
};

export default TextField;
